export default __webpack_public_path__ + "static/media/no_querystrings.48ae73a9.png";